import { createContext, useContext, useState } from 'react';

const KapatmaContext = createContext(null);

export function KapatmaProvider({ children }) {
  const [kapatmalar, setKapatmalar] = useState([]);

  function kapatmaEkle(kayit) {
    setKapatmalar(function(prev) { return prev.concat(kayit); });
  }

  function kapatmaSil(id) {
    setKapatmalar(function(prev) { return prev.filter(function(k) { return k.id !== id; }); });
  }

  return (
    <KapatmaContext.Provider value={{ kapatmalar, kapatmaEkle, kapatmaSil }}>
      {children}
    </KapatmaContext.Provider>
  );
}

export function useKapatma() {
  return useContext(KapatmaContext);
}